import { CSSProperties, FC, ReactNode } from 'react';
import { useAutoAnimate } from '@formkit/auto-animate/react';

export const SIDER_COLLAPSE_ANIMATION_DURATION = 175;

interface AnimatedCollapsibleContentProps {
    children: ReactNode;
    className?: string;
    collapsed: boolean;
    style?: CSSProperties;
}

const AnimatedCollapsibleContent: FC<AnimatedCollapsibleContentProps> = ({ children, className, collapsed, style }) => {
    const [animationParent] = useAutoAnimate({
        duration: SIDER_COLLAPSE_ANIMATION_DURATION,
        easing: 'ease-in-out',
    });

    return (
        <div className={className} ref={animationParent} style={style}>
            {collapsed ? null : children}
        </div>
    );
};

export default AnimatedCollapsibleContent;
